function parseJwt(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
}

export function checkAuthStatus() {
    const token = localStorage.getItem('accessToken');
    if (!token) {
        return { isAuthenticated: false };
    }

    const decodedToken = parseJwt(token);

    if (!decodedToken || !decodedToken.exp) {
        localStorage.removeItem('accessToken');
        return { isAuthenticated: false };
    }

    const isExpired = decodedToken.exp * 1000 < Date.now();

    if (isExpired) {
        localStorage.removeItem('accessToken');
        return { isAuthenticated: false };
    }

    return { isAuthenticated: true };
}

export function logout() {
    localStorage.removeItem('accessToken');
    window.location.href = '/login';
}
